import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from './block/table';
import {setGetReplenishmentUser} from '../../store/thunk/setGetReplenishmentUser';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, getRows, useStyles} from './helpers';

const BlockReplenishment = ({login}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [deposit, setDeposit] = React.useState(false);

    React.useEffect(() => {
        if (deposit) {
            dispatch(setGetReplenishmentUser({
                id: login,
                page: 1,
                rowsPerPage: 5
            }));
        }
    }, [deposit, login]);

    const replenishment = useSelector(state => state.users.user_replenishment);
    const rows = React.useMemo(() => getRows(replenishment.data), [replenishment]);

    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setDeposit(!deposit)
                }}
            >
                <span
                    className={classes.title}
                >Депозиты</span>
                {
                    !deposit && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    deposit && 
                    <ArrowDown className={classes.arrow}/> 
                }
            </div>
            <div>
                {
                    deposit && login &&
                    <TableCasino
                        allPage={replenishment.count}
                        width={1280}
                        perPage={10}
                        columns={columns}
                        rows={rows}
                        changeRowsPerPage={(v) => dispatch(setGetReplenishmentUser({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id: login,
                        }))}
                    /> 
                }
            </div>
        </div>
    )
}

export default BlockReplenishment;